import elearningLocale from './en.json'

const en = {
  elearning: elearningLocale,
}

export default en
